/* Breakfree Black Friday: picks the banner for today's date and runs the countdowns */
(function () {
  'use strict';
  if (window.bfBlackFriday) { window.bfBlackFriday.scan(); return; }

  var KEYS = ['soon', 'live', 'cyber'];
  var mounted = [], timer = null;

  function at(day, tz) {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})\s*$/.exec(day || '');
    if (!m) return null;
    var z = /^[+-]\d{2}:\d{2}$/.test(String(tz || '').trim()) ? String(tz).trim() : '+02:00';
    var t = Date.parse(m[1] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[3]).slice(-2) + 'T00:00:00' + z);
    return isNaN(t) ? null : t;
  }
  function urlTest() { var m = /[?&]bf=(soon|live|cyber|preview|early)(&|$)/.exec(location.search); return m ? ({ preview: 'live', early: 'soon' }[m[1]] || m[1]) : ''; }
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  function parts(ms) { ms = Math.max(0, ms); var s = Math.floor(ms / 1000); return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 }; }

  /* phase k runs from its date to the next date */
  function phases(c) {
    var t = [at(c.d1, c.tz), at(c.d2, c.tz), at(c.d3, c.tz), at(c.d4, c.tz)];
    return KEYS.map(function (k, i) { return { k: k, a: t[i], b: t[i + 1], on: !!(c.on && c.on[k]) }; });
  }
  function pick(st, now) {
    var forced = st.c.test || urlTest(), list = st.ph;
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (forced) { if (p.k === forced) return p; continue; }
      if (p.on && p.a != null && p.b != null && now >= p.a && now < p.b) return p;
    }
    return null;
  }

  function show(st) {
    var p = pick(st, Date.now()), key = p ? p.k : '';
    if (st.key === key && st.done) return;
    st.key = key; st.p = p; st.done = true;
    var out = st.el.querySelector('[data-bf-out]');
    out.innerHTML = '';
    if (!p) {
      if (st.c.design) { out.innerHTML = st.el.querySelector('template[data-bf-empty]') ? st.el.querySelector('template[data-bf-empty]').innerHTML : ''; st.el.hidden = false; }
      else st.el.hidden = true;
      return;
    }
    var tpl = st.el.querySelector('template[data-ph="' + p.k + '"]');
    if (!tpl) { st.el.hidden = true; return; }
    out.appendChild(tpl.content.cloneNode(true));
    st.el.hidden = false;
    st.el.setAttribute('data-phase', p.k);
    paint(st);
  }
  function paint(st) {
    if (!st.p || st.p.b == null) return;
    var x = parts(st.p.b - Date.now());
    [].forEach.call(st.el.querySelectorAll('[data-u]'), function (n) { var v = p2(x[n.getAttribute('data-u')]); if (n.textContent !== v) n.textContent = v; });
    [].forEach.call(st.el.querySelectorAll('[data-unit="d"]'), function (n) { n.hidden = x.d === 0; });
    [].forEach.call(st.el.querySelectorAll('[data-cd]'), function (n) {
      var v = (x.d ? x.d + 'd ' : '') + p2(x.h) + ':' + p2(x.m) + ':' + p2(x.s);
      if (n.textContent !== v) n.textContent = v;
    });
  }
  function tick() {
    var now = Date.now();
    mounted = mounted.filter(function (st) { return document.documentElement.contains(st.el); });
    mounted.forEach(function (st) {
      if (st.p && !st.c.test && !urlTest() && st.p.b != null && now >= st.p.b) { st.done = false; show(st); }
      else if (!st.p && !st.c.test) { var p = pick(st, now); if (p) { st.done = false; show(st); } }
      else paint(st);
    });
  }
  function mount(el) {
    if (el.__bf) return;
    var c;
    try { c = JSON.parse(el.getAttribute('data-bfbf')); } catch (e) { return; }
    var st = { el: el, c: c, ph: phases(c), key: null, p: null, done: false };
    el.__bf = st;
    mounted.push(st);
    show(st);
    if (!timer) timer = setInterval(tick, 1000);
  }
  function scan() { [].forEach.call(document.querySelectorAll('[data-bfbf]'), mount); }

  window.bfBlackFriday = { scan: scan };
  scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();